/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Code_LabelInputs */

const vi_customer_code_label = /** @type {(inputs: Customer_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã KH`)
};

/**

* @param {Customer_Code_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_code_label = /** @type {((inputs?: Customer_Code_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Code_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_code_label(inputs)
});